<template>
  <div class="agreement-page">
    <header>
      <h1>【养只啵啵鼻】隐私协议</h1>
      <div class="version">版本日期: 2026年02月12日</div>
    </header>

    <main>
      <section v-for="(sec, idx) in privacyAgreement" :key="idx">
        <h3>{{ sec.title }}</h3>
        <div v-html="sec.content"></div>
      </section>
    </main>

    <footer>
      <p>© 2025 上海万愈科技有限公司 版权所有</p>
    </footer>
  </div>
</template>

<script>
export default {
  name: "PrivacyAgreement",
  data() {
    return {
      privacyAgreement: [
        {
          title: "引言",
          content: `本隐私政策适用于上海万愈科技有限公司的养只啵啵鼻产品及服务。我们非常重视用户个人信息的保护，并且将以勤勉和审慎的义务对待这些信息。您在下载、安装、开启、注册、登录、使用(以下统称“使用”)【养只啵啵鼻】软件及相关服务时，我们将按照本《隐私政策》收集、保存、使用、共享、披露及保护您的个人信息。我们希望通过本《隐私政策》向您介绍我们对您个人信息的处理方式，因此我们建议您认真完整地阅读本《隐私政策》的所有条款。其中，与您信息及权利相关的内容将以加粗的形式提示您注意，请您重点阅读。<br>
本隐私政策旨在帮助您了解以下内容：<br>一、我们如何收集和使用个人信息和申请相关权限；<br>二、我们对 Cookie 和同类技术的使用；<br>三、我们如何存储个人信息；<br>四、我们如何共享、转让、公开披露个人信息；<br>五、我们如何保护个人信息的安全；<br>六、您的权利；<br>七、未成年人使用条款；<br>八、隐私政策的修订和通知；<br>九、适用范围；<br>十、其他；<br>十一、历史版本；<br>十二、如何联系我们；<br>十三、第三方 SDK 使用说明。`
        },
        {
          title: "一、我们如何收集和使用个人信息和申请相关权限",
          content: `在您使用养只啵啵鼻软件及服务的过程中，我们将根据合法、正当、必要的原则，收集信息。我们收集或请您提供的信息将用于:<br>
1.保障产品的基础正常运行;<br>
2.实现各项功能和服务;<br>
3.优化、改善产品和服务;<br>
4.保障产品、服务以及用户使用安全;<br>
5.遵循法律法规与国家标准的规定。<br>
A.我们直接收集与使用的个人信息<br>
我们会按照如下方式收集您在使用服务时主动提供的，以及通过自动化手段收集您在使用功能或接受服务过程中产生的信息:<br>
1.保障【养只啵啵鼻】的正常运行<br>
当您使用【养只啵啵鼻】及相关服务时，为了保障软件与服务的正常运行，我们会收集您的移动设备硬件型号、操作系统版本号、设备识别码、设备型号、唯一设备标识符信息(IMEI/android ID/OPENUDID/GUID)、设备序号、网络设备硬件地址(设备MAC地址)、IP地址、软件版本号、网络接入方式及类型、操作日志、设备存储读写权限、地理位置信息。请您了解，这些信息是我们提供服务和保障产品正常运行所必须收集的基本信息。<br>
2.注册、认证、登录【养只啵啵鼻】和相关服务<br>
(1)您也可以使用第三方帐号(微信)登录【养只啵啵鼻】。您此时将授权我们获取您在第三方平台注册的公开信息(头像、昵称)，并在您同意本隐私政策后将您的第三方账号与您的养只啵啵鼻账户绑定，使您可以通过第三方账号直接登录并使用本产品和相关服务。您也可根据自身需求选择填写昵称，头像，性别、生日、完善您的个人信息。<br>
(2)如您未登录则会影响您使用【养只啵啵鼻】，需要登录后才可体验到功能。您提供的上述信息，将在您使用本服务期间持续授权我们使用。在您注销账号时，我们将停止使用并删除上述信息。<br>
3.为您提供内容信息发布功能或服务<br>
(1)您主动发布内容时，我们将收集您所发布的内容信息，并根据您设置的可见权限，展示您的签名、头像、发布的信息内容。并对您发布的内容依据国家法律进行审核。<br>
4.为您提供互动功能或服务<br>
(1)您主动关注的账号并与其他账号进行互动，进行回应或分享内容时，我们会收集您关注的账号，并向您展示您关注账号发布内容。<br>
5.获取当前正在使用的软件信息、当前正在运行的应用进程(本地使用，不会上报存储)<br>
6.保障产品、服务及用户使用安全<br>
为帮助我们更好地了解【养只啵啵鼻】及相关服务的运行情况，以便确保运行与提供服务的安全，我们记录网络日志信息，以及使用软件及相关服务的频率、崩溃数据、总体安装、使用情况、性能数据信息。<br>
7.第三方SDK接入服务所需开通的权限<br>
(1)我们的产品和服务包括第三方的产品和服务，以及第三方网站的链接。当您使用这些产品或服务时，第三方会收集您的信息，具体手机信息以第三方隐私政策为准。您可以通过本政策第十三条“第三方SDK使用说明”进行详细了解。<br>
(2)对第三方SDK的接入，我们仅会出于合法、正当、必要、特定、明确的目的共享您的个人信息，并只会共享提供服务所必要的个人信息，对于其他不必要信息我们会采取匿名化处理。同时，我们还会与其签署严格的保密协定，要求其按照我们的说明、本隐私政策以及其他任何相关保密和安全措施来处理。<br>
(一)软件使用过程申请的权限说明(使用时基于用户授权后才会获取)<br>
(1)在使用软件的激活账户，浏览内容过程中，为能您提供推送服务，需要您提供读取电话状态(获取设备IMSI、IMEI号、MAC地址)设备信息权限，用于获取设备信息，反作弊，保证账号安全的正常，否者很多数据的提供都无法正常进行。<br>
(2)在使用软件获取网络数据过程中，我们需要向你的设备中临时存储和读取网络数据，需要您提供手机存储读写权限。<br>
(3)位置信息：当您使用和啵啵鼻对话功能时，因包含天气主题内容，经您单独授权，我们会申请获取您设备的精确位置信息（经纬度），用于为您的小宠物提供当地实时天气数据，以便其向您播报天气、推送穿衣/出行提醒。<br>
(二)收集、使用个人信息目的变更的处理<br>
请您了解，随着我们业务的发展，我们会对养只啵啵鼻的功能和提供的服务有所调整变化。当新功能或服务与内容发布、互动交流、注册认证、虚拟财产场景相关时，收集与使用的个人信息属于与原目的具有直接或合理关联。在与原目的无直接或合理关联的场景下，我们收集、使用您的个人信息，会再次进行告知，并征得您的同意。<br>
(三)、自启动和关联互动说明<br>
1.为确保本应用处于关闭或后台运行状态下可正常接收到客户端推送的广播信息，本应用须使用(自启动)能力，将存在一定频率通过系统发送广播唤醒本应用自启动或关联启动行为，是因实现小组件更新和维持长链接功能及服务所必要的。<br>
2.当您打开养只啵啵鼻推送消息和小组件后，在征得您的明确同意后，会跳转养只啵啵鼻打开相关内容。在未征得您同意的情况下，则不会有关联启动。<br>
3.第三方SDK: 包含微信登录SDK、支付宝SDK、极光推送SDK、Bugly SDK.<br>
为确保应用正常运行，优化用户体验，检测Bug，微信SDK、极光推送SDK、Bugly SDK等(详细见第三方SDK列表内容)将会获取手机IMSI个人信息。主要用于提供问题追踪、排查、诊断服务并进行数据统计，以保障产品和服务安全正常运行，将收集IMSI个人信息。<br>
极光推送 SDK：为了向您及时推送消息，该 SDK 可能会通过自启动或关联启动机制保持与服务器的连接。这属于实现推送功能所必需的合理场景。<br>
(四)依法豁免征得同意收集和使用的个人信息<br>
请您理解，在下列情形中，根据法律法规及相关国家标准，我们收集和使用您的个人信息无需征得您的授权同意:<br>
(1)与国家安全、国防安全直接相关的;<br>
(2) 与公共安全、公共卫生、重大公共利益直接相关的;<br>
(3) 与犯罪侦查、起诉、审判和判决执行等直接相关的;<br>
(4)出于维护个人信息与其他个人的生命、财产等重大合法权益但又很难得到本人同意的;<br>
(5)所收集的您的个人信息是您自行向社会公众公开的;<br>
(6)从合法公开披露的信息中收集的您的个人信息的，如合法的新闻报道、政府信息公开等渠道;<br>
(7)涉及商业秘密的;<br>
(8)为合法的新闻报道所必需的;<br>
(9)学术研究机构基于公共利益开展统计或学术研究所必要，且对外提供学术研究或描述的结果时，对结果中所包含的个人信息进行去标识化处理的;<br>
(10)法律法规规定的其他情形。<br>
请您注意，目前【养只啵啵鼻】不会主动向集团外的第三方获取您的个人信息。如未来为业务发展需要从第三方间接获取您个人信息，我们会在获取前向您明示您个人信息的来源、类型及使用范围，如养只啵啵鼻开展业务需进行的个人信息处理活动超出您原本向第三方提供个人信息时的授权同意范围，我们将在处理您的该等个人信息前，征得您的明示同意;此外，我们也将会严格遵守相关法律法规的规定，并要求第三方保障其提供的信息的合法性。`,
        },
        {
          title: "二、对Cookie和同类技术的使用",
          content: `Cookie和同类技术是互联网中的通用常用技术。当您使用养只啵啵鼻及相关服务时，我们会使用相关技术向您的设备发送一个或多个Cookie或匿名标识符，以收集和存储您访问、使用本产品时的信息。我们使用Cookie和同类技术主要为了实现以下功能或服务:<br>
(一)保障产品与服务的安全、高效运转<br>
我们会设置认证与保障安全性的cookie或匿名标识符，使我们确认您是否安全登录服务，或者是否遇到盗用、欺诈不法行为。这些技术还会帮助我们改进服务效率，提升登录和响应速度。<br>
(二)帮助您获得更轻松的访问体验<br>
使用此类技术可以帮助您省去重复您填写个人信息、输入搜索内容的步骤和流程(实现一键登录流程、记录搜索历史)。`,
        },
        {
          title: "三、我们如何存储个人信息",
          content: `(一)信息存储的地点<br>
我们依照法律法规的规定，将在运营过程中收集和产生的您的个人信息存储于中华人民共和国境内。<br>
(二)存储期限<br>
我们仅在为提供养只啵啵鼻及服务所必需的期间内保留您的个人信息，包括您发布的内容信息、收藏、点赞信息，在您未撤回、删除或未注销账号期间，我们会保留相关信息3年，操作日志根据法律规定不低于6个月。超出必要期限后，我们将对您的个人信息进行删除处理，但法律法规另有规定的除外。`,
        },
        {
          title: "四、我们如何共享、转让、公开披露个人信息",
          content: `(一)共享<br>
我们不会与其他的任何公司、组织和个人分享您的个人信息，但以下情况除外:<br>
1.在获取明确同意的情况下共享:获得您的明确同意后，我们会与其他方共享您的个人信息。<br>
2.我们会根据法律法规规定，或按政府主管部门的强制性要求，对外共享您的个人信息。<br>
3.与集团公司共享:我们只会共享必要的个人信息，且受本隐私政策中所声明目的的约束。如要改变个人信息的处理目的，将再次征求您的授权同意。<br>
4.与授权合作伙伴共享:仅为实现本政策中声明的目的，我们的某些服务将由授权合作伙伴提供。我们会与合作伙伴共享您的某些个人信息，以提供更好的客户服务和用户体验。我们的合作伙伴无权将共享的个人信息用于任何其他用途。<br>
目前，我们的授权合作伙伴主要为：<br>
供应商、服务提供商和其他合作伙伴。我们将信息发送给在全球范围内支持我们业务的供应商、服务提供商和其他合作伙伴，这些支持包括提供技术基础设施服务、分析我们服务的使用方式、衡量广告和服务的有效性、提供客户服务、支付便利或进行学术研究和调查。<br>
对我们与之共享个人信息的公司、组织和个人，我们会与其签署严格的保密协定，要求他们按照我们的说明、本隐私政策以及其他任何相关的保密和安全措施来处理个人信息。<br>
(二)转让<br>
我们不会将您的个人信息转让给任何公司、组织和个人，但以下情况除外:<br>
1.在获取明确同意的情况下转让:获得您的明确同意后，我们会向其他方转让您的个人信息;<br>
2.在涉及合并、收购或破产清算时，如涉及到个人信息转让，我们会在要求新的持有您个人信息的公司、组织继续受此隐私政策的约束否则我们将要求该公司、组织重新向您征求授权同意。<br>
(三)公开披露的个人信息<br>
请您理解，在下列情形中，根据法律法规及国家标准，我们共享、转让、公开披露您的个人信息无需征得您的授权同意:<br>
(1)获得您明确同意后;<br>
(2)与国家安全、国防安全直接相关的;<br>
(3) 与公共安全、公共卫生、重大公共利益直接相关的;<br>
(4) 与犯罪侦查、起诉、审判和判决执行等直接相关的;<br>
(5)出于维护您或其他个人的生命、财产等重大合法权益但又很难得到您的同意的;<br>
(6)您自行向社会公众公开的个人信息;<br>
(7)从合法公开披露的信息中收集个人信息的，如合法的新闻报道、政府信息公开等渠道。`,
        },
        {
          title: "五、我们如何保护个人信息安全",
          content: `(一)我们非常重视您个人信息的安全，将努力采取合理的安全措施(包括技术方面和管理方面)来保护您的个人信息，防止您提供的个人信息被不当使用或未经授权的情况下被访问、公开披露、使用、修改、损坏、丢失或泄漏。<br>
(二)我们会使用加密技术、匿名化处理等合理可行的手段保护您的个人信息，并使用安全保护机制防止您的个人信息遭到恶意攻击。<br>
(三)我们会建立专门的安全部门、安全管理制度、数据安全流程保障您的个人信息安全。我们采取严格的数据使用和访问制度，确保只有授权人员才可访问您的个人信息，并适时对数据和技术进行安全审计。<br>
(四)互联网环境并非百分之百安全，我们将尽力确保或担保您发送给我们的任何信息的安全性。但在同时，我们强烈建议您采取积极措施保护个人信息的安全，包括但不限于使用复杂密码、定期修改密码、不将自己的账号密码个人信息透露给他人。<br>
(五)在不幸发生个人信息安全事件后，我们将按照法律法规的要求，及时向您告知:安全事件的基本情况和影响、我们已采取或将要采取的处置措施、您可自主防范和降低风险的建议、对您的补救措施。我们将及时将事件相关情况以邮件、信函、电话方式告知您，难以逐一告知个人信息主体时，我们会采取合理、有效的方式发布公告。<br>
同时，我们还将按照监管部门要求，主动上报个人信息安全事件的处置情况。`,
        },
        {
          title: "六、您的权利",
          content: `按照中国相关的法律、法规、标准，以及其他国家、地区的通行做法，我们非常重视您对个人信息的管理，并尽全力保护您对于您个人信息的访问、修改(更新或更正)、删除以及改变授权同意的权利，以使您有能力保障您的隐私和安全。<br>
(一)访问、更正、删除您的个人信息您可以通过以下方式管理您的信息:<br>
当您完成养只啵啵鼻的账号注册、登录并进行合理和必要的身份验证后，您可以查阅、修改、删除您提交给【养只啵啵鼻】软件及相关服务的个人信息(包括删除您的心情日记)。<br>
一般情况下，您可以直接删除您发布的内容，或是在客户端应用程序中点击右下方的【我的]进入个人中心，点击上方的【头像]或【昵称]随时浏览、修改、删除自己提交的信息，但出于安全性和身份识别的考虑，您无法自主修改注册时提交的某些初始注册信息，请您通过电子邮件至 Lucas@wanyutec.com.cn，联系我们的个人信息保护专员申请更改，我们将尽快审核所涉问题，并由专人验证您的用户身份后及时予以回复。<br>
(二)管理、撤回授权您的信息<br>
您可以通过删除信息、关闭设备功能、在养只啵啵鼻客户端应用程序中点击右下方的【我的】进入个人中心，通过右上方的【设置图标]-[隐私设置]，改变您的授权。<br>
请您理解，特定的业务功能和服务将需要您的信息才能得以完成，当您撤回同意或授权后，公司无法继续为您提供撤回同意或授权所对应的功能和服务，也不再处理您相应的个人信息。但您撤回同意或授权的决定，不会影响公司此前基于您的授权而开展的个人信息处理。<br>
(三)注销您的账号<br>
我们支持您随时注销此前注册的账户，您可以通过以下方式进行:<br>
(1)通过点击首页左上角图标进入【设置页】—点击【账号设置】—选择【注销账号】，按页面提示完成注销申请。<br>
在您注销账户之后，我们将停止为您提供产品或服务，并依据您的要求删除或匿名化处理您的个人信息；法律法规另有规定或监管要求需要留存的除外。<br>
<br>
(四)投诉举报<br>
如果您认为您的个人信息权利受到侵害，或者发现侵害个人信息权利的线索，您可以通过联系:Lucas@Wanyutec.com.cn进行投诉或举报。我们核查后会尽快给您反馈。<br>
(五)访问隐私政策<br>
通过点击首页左上角图标进入【设置页】— 点击【关于我们】—点击《隐私协议》查看本隐私政策的全部内容。<br>
<br>
<br>
(六)停止运营向您告知权利<br>
如我们停止运营，我们将及时停止收集您个人信息的活动，将停止运营的通知以逐一通过电子邮件、信函、电话、公告形式通知您，并对所持有的您的个人信息进行删除或匿名化处理。`,
        },
        {
          title: "七、未成年人使用条款",
          content: `我们非常重视对未成年人个人信息的保护。根据相关法律法规的规定，若你是18周岁以下的未成年人，在使用【养只啵啵鼻】服务前，应事先取得你的家长或法定监护人的书面同意。若你是未成年人的监护人，当你对你所监护的未成年人的个人信息有相关疑问时，请通过本协议文首的联系方式与我们联系。`,
        },
        {
          title: "八、隐私政策的修订和通知",
          content: `(一)为了给您提供更好的服务，【养只啵啵鼻】软件及相关服务将不时更新与变化，我们会适时对本隐私政策进行修订，该等修订构成本隐私政策的一部分并具有等同于本隐私政策的效力。但未经您明确同意，我们不会削减您依据当前生效的本隐私政策所应享受的权利。<br>
(二)本隐私政策更新后，我们会在养只啵啵鼻应用程序客户端和官方网站发出更新版本，并在更新后的条款生效前以适当的方式提醒您更新的内容，以便您及时了解本隐私政策的最新版本。如您继续使用我们的服务，表示同意接受修订后的本政策的内容，但是如果更新的内容需要采集内容、获取您联系方式、地理位置个人敏感信息，仍会再次以显著方式征求您的同意。<br>
(三)对于重大变更，我们还会提供更为显著的通知(我们会通过包括但不限于邮件、短信、私信或在浏览页面做特别提示方式，说明隐私政策的具体变更内容）。<br>
本隐私政策所指的重大变更包括但不限于:<br>
1.我们的服务模式发生重大变化。如处理个人信息的目的、处理的个人信息的类型、个人信息的使用方式;<br>
2.我们在所有权结构、组织架构方面发生重大变化。如业务调整、破产并购引起的所有变更;<br>
3.个人信息共享、转让或公开披露的主要对象发生变化;<br>
4.您参与个人信息处理方面的权利及其行使方式发生重大变化;<br>
5.我们负责处理个人信息安全的责任部门、联络方式及投诉渠道发生变化时。`,
        },
        {
          title: "九、适用范围",
          content: `本隐私权政策适用于由上海万愈科技有限公司及其关联方提供的所有服务，包括【养只啵啵鼻】客户端、网站，不适用于有单独的隐私权政策且未纳入本隐私权政策的第三方产品或服务。本隐私权政策不适用于:<br>
1.其他第三方产品或服务，包括向您显示的产品或网站或者【养只啵啵鼻】服务中链接到的其他产品或网站;<br>
您使用这些第三方服务(包括您向这些第三方提供的任何个人信息)，将受这些第三方的服务条款及隐私政策约束(而非本隐私政策)，具体规定请您仔细阅读第三方的条款。请您妥善保护自己的个人信息，仅在必要的情况下向第三方提供。<br>
本隐私政策中所述的【养只啵啵鼻】及相关服务有会根据您所使用的手机型号、系统版本、软件应用程序版本因素而有所不同。最终的产品和服务以您所使用的【养只啵啵鼻】及相关服务为准。`,
        },
        {
          title: "十、其他",
          content: `(一)本“隐私政策”中的标题仅为方便及阅读而设，并不影响本《隐私政策》中任何规定的含义或解释。<br>
(二)本“隐私政策”相关词语释义:<br>
【养只啵啵鼻】及相关服务是指公司及其关联方通过合法拥有并运营的、标注名称为【养只啵啵鼻】的客户端应用程序以您提供的产品与服务，包括但不限内容发布、浏览功能。<br>
1.关联方是指，指一方现在或将来控制、受控制或与其处于共同控制下的任何公司、机构以及上述公司或机构的法定代表人。“控制”是指直接或间接地拥有影响所提及公司管理的能力，无论是通过所有权、有投票权的股份、合同或其他被依法认定的方式。<br>
2.个人信息是指，以电子或者其他方式记录的能够单独或者与其他信息结合识别特定自然人身份或者反映特定自然人活动情况的各种信息，包括个人身份信息(姓名、出生日期、身份证件号码，包括身份证、军官证、护照、驾驶证)、面部特征、地址、联系电话、通信录、网络身份识别信息(包括账号名、账号昵称、邮箱地址以及与前述有关的密码与密码保护问题和答案);财产信息、交易信息、个人上网记录(网络浏览记录、点击记录)、个人常用设备信息(包括硬件型号、设备MAC地址、操作系统类型、软件列表唯一设备识别码在内的描述个人常用终端设备基本情况的信息)、个人位置信息。<br>
3.个人敏感信息是指，一旦泄露、非法提供或滥用可能危害人身和财产安全，极易导致个人名誉、身心健康受到损害或歧视性待遇的个人信息。本隐私政策中的个人敏感信息包括:包括个人身份信息(身份证件号码，包括身份证、军官证、护照、驾驶证)、面部识别特征;财产信息、交易信息;网络身份识别信息(包括账号名、账号昵称、邮箱地址以及与前述有关的密码与密码保护问题和答案);其他信息(包括通信录、个人电话号码、行程信息、精准定位信息)。<br>
4.去标识化是指，通过对个人信息的技术处理，使其在不借助额外信息的情况下，无法识别个人信息主体的过程。<br>
5.匿名化是指，通过对个人信息的技术处理，使得个人信息主体无法被识别，且处理后的信息不能被复原的过程。<br>
(三)本“隐私政策”的版权为我们所有，在法律允许的范围内，我们拥有解释和修改的权利。`,
        },
        {
          title: "十一、历史版本:",
          content: `2026年2月12日更新内容为：（一）.7.1关于收集用户地理位置的说明。`,
        },
        {
          title: "十二、如何联系我们",
          content: `如对本隐私政策有任何疑问、意见或建议，请联系我们：<br>邮箱: Lucas@wanyutec.com.cn。`
        },
        {
          title: "十三、第三方信息共享清单",
          content: `为保障【养只啵啵鼻】相关功能的实现与应用安全稳定的运行，我们可能会接入由合作方提供的软件开发包(SDK)、应用程序接口(API)、应用程序插件等代码或通过其他合作方式，以实现相关目的。但我们会对获取信息的合作方的代码进行严格的安全监测，以保护数据安全。我们会将接入的相关合作方名单在以下列明，合作方具体的处理情况请参见合作方的隐私政策或服务协议，如有变化，请以其公示的官方说明为准。<br>
SDK&amp;API;<br>
1、SDK名称：微信OpenSDK Android<br>
使用目的:支持微信登录、分享、微信支付<br>
收集信息范围:设备标识符(Android如IMEI、Androi dID、Serial，iOS如IDFV)、MAC地址、SD卡数据、WLAN接入点、分享图片或内容<br>
开发者:深圳市腾讯计算机系统有限公司<br>
合作方隐私政策链接: https://support.weixin.qq.com/cgi-bin/mmsupportacctnodeweb-bin/pages/RYiYJkLOrQwu0nb8<br>
<br>
2、SDK名称：极光推送 - JPush SDK - Android<br>
使用目的:实现系统消息推送服务<br>
收集信息范围:AndroidID、唯一设备标识、设备信息、SD卡数据、网络信息、位置信息、软件列表(JPushSDK会收集AndroidID)、BSSID、SSID信息<br>
使用场景: 应用内通知推送, 提供应用拉起服务。获取应用列表，查找同一设备上集成JPush SDK的其他应用，完成应用间拉起，以提高推送消息到达率。使用地理围栏以及分群推送功能。请注意，该 SDK 可能会通过自启动或关联启动机制保持与服务器的连接。这属于实现推送功能所必需的合理场景。<br>
开发者:深圳市和讯华谷信息技术有限公司<br>
合作方隐私政策链接: https://www.jiguang.cn/license/privacy<br>
<br>
3、SDK名称：Bugly Android<br>
使用目的:检测软件运行稳定性<br>
收集信息范围:设备信息、IMSI、唯一设备识别码(MAC/IMEI/androiID/OPENUDID/GUID/SIM卡IM SI信息\\SD卡数据)、android.permission.ACCESS_NE TWORK_STAT、android.permission.INTERNET<br>
使用场景:查看网络状态，用于数据上报，实现开发者查看崩溃信息的目的<br>
开发者:深圳市腾讯计算机系统有限公司<br>
合作方隐私政策链接: https://privacy.qq.com/document/preview/fc748b3d96224fdb825ea79e132c1a56<br>
<br>
4、SDK名称：APP支付客户端SDK<br>
使用目的:购买增值服务<br>
收集信息范围: IMEI、IMSI、MAC 地址、设备序列号、硬件序列号、SIM 卡序列号、ICCI D、; Android ID、OAID、SSID、BSSID;系统设置、系统属性、设备型号、设备品牌、操作系统;IP 地址、网络类型、运营商信息、Wi- Fi 状态、 Wi-Fi 参数、Wi-Fi 列表;软件安装列表。<br>
开发者:支付宝(杭州)信息技术有限公司<br>
合作方隐私政策链接: https://opendocs.alipay.com/open/54/01g6qm?pathHash=01459d85`
        }
      ]
    };
  }
};
</script>

<style scoped>
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}
body {
  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, "Noto Sans", sans-serif;
  background: #f5f7fa;
  color: #333;
}
.agreement-page {
  max-width: 800px;
  margin: 0 auto;
  padding: 0 16px;
}
header {
  background: #4a5568;
  border-bottom: 1px solid #e2e8f0;
  padding: 20px 0;
  text-align: center;
}
header h1 {
  font-size: 24px;
  color: #fff;
}
.version {
  color: #e6edf3;
  font-size: 12px;
  margin-top: 6px;
}
main {
  background: #fff;
  border-radius: 8px;
  padding: 24px 32px;
  margin-top: 24px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);
  color: #4a5568;
  line-height: 1.8;
  font-size: 14px;
}
section {
  margin-bottom: 28px;
}
section h3 {
  font-size: 16px;
  margin-bottom: 8px;
  font-weight: 600;
}
section div {
  font-size: 14px;
  line-height: 1.8;
  color: #4a5568;
}
footer {
  text-align: center;
  padding: 20px 0;
  font-size: 12px;
  color: #a0aec0;
}
</style>
